import React, { Component } from 'react'

import Controls from '../common/controls'

class ScreenerIneligible extends Component {
  constructor(props) {
    super(props)
    this.next = this._next.bind(this)
  }

  _next() {
    return this.props.next(this.props.match.path)
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div className="screener-wrapper" id="screener_eligible">
        <div className="container flex">
          <h3 className="screener-label">The Newtopia program is designed to help those who are at-risk for developing type two diabetes, heart disease, or stroke.</h3>
          <h3 className="screener-label">At this time, it looks like you're not a candidate (which is good news!).</h3>
          <h3 className="screener-label">Please contact your HR group to find out what other programs are being offered that may be a better fit.</h3>
          <Controls className="screener-button" buttonClassName="screener" nextLabel="REVIEW MY ANSWERS" next={this.next} />
        </div>
      </div>
    )
  }
}

export default ScreenerIneligible